import { createContext } from 'react'

import { AnalyticsContextProps } from './AnalyticsContext.types'

const defaultAnalyticsContext = {
  analytics: undefined
}

export const AnalyticsContext = createContext<AnalyticsContextProps>(defaultAnalyticsContext)
